import React, { Fragment } from 'react';
import { Footer as FooterBase, Query } from 'shared';
import { adaptApiLink } from 'utils';

import { FooterProps } from './Footer.types';

export const Footer = ({ onFetchBottomNavigation }: FooterProps) => (
  <Query onFetch={onFetchBottomNavigation}>
    {({ error, loading, response }) => (
      <Fragment>
        <FooterBase
          links={!loading && !error && response ? response.payload.map(l => adaptApiLink(l)) : []}
          groups={[]}
        />
      </Fragment>
    )}
  </Query>
);
